import getKhattabatStore from "../../../stores/khattabat-stores";
import getKhattabatAiMessagesStore from "../../../stores/khattabat-stores/ai-messages";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import AiMessages from "./ai-messages";
import Client from "./Client";
import Selects from "./selects";
import Header from "./header";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import AiClientsCount from "./AiClientsCount";

const KhattabatClients = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const clients = getKhattabatStore().getClients.get();
  getKhattabatAiMessagesStore().initializeInputFields();
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={1520}
      height={0}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Header />
      {isAiKhattaba ? <AiClientsCount /> : <Selects />}
      <Et3Margin top={50} bottom={50} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={1520}
        height={0}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        {clients.map((client) => {
          return (
            <Client
              userName={client.userName}
              vipKhattabaStatus={client.vipAlkhattabatStatus}
              alkhattabaUUID={client.alkhattabaUUID}
              oneOOneCId={client.oneOOneCId}
              userUUID={client.userUUID}
              userID={client.userID}
              originCountry={client.originCountry}
              residenceCoutry={client.residenceCoutry}
              height={client.height}
              weight={client.weight}
              age={client.age}
              lastLogin={client.lastLogin}
              marriageType={client.marriageType}
              unreadOneOOneCMessages={client.unreadOneOOneCMessages}
              oneOTwoCounter={client.oneOTwoCounter}
              isOneOOneCHiddenByKhattaba={client.isOneOOneCHiddenByKhattaba}
              applicationStatus={client.applicationStatus}
              isInItroductoryPhase={client.isInItroductoryPhase}
            />
          );
        })}
      </ET3Div>
      <AiMessages pageType="clientPage" />
    </ET3Div>
  );
});
export default KhattabatClients;
